import * as React from "react";
import { Button } from "@blueprintjs/core";
import { PersonApi, PersonGridDto, PersonSearch } from "../../../../../api";
import { CustomDataTable, SearchTablePage } from "../../../../../components";
import { useApiService, useTl } from "../../../../../hooks";
import { useGlobalData } from "../../../../../contexts";
import { ButtonContainer, IDataTableColumn, useGridState, useSearchApi } from "nsitools-react";
import { ETLCodes } from "../../../../../locales";
import { generateAddress } from "../../../../../utils/generateAddress";

export interface IClubContactSelectorPanelProps {
  onContactSelected: (contact: PersonGridDto) => void;
}

export const ClubContactSelectorPanel: React.FunctionComponent<IClubContactSelectorPanelProps> = (props) => {
  const api = useApiService(PersonApi);
  const { t } = useTl();

  const tableState = useGridState<any>({
    serverMode: true,
    enablePagination: true,
    enableFilter: true,
    availablePageSizes: [5, 10],
    pageSize: 10,
  });

  const searchFunction = React.useCallback((sObj?: PersonSearch) => api.baseSearch(sObj), [api]);

  const { loading } = useSearchApi<any, any>({
    searchFunction,
    tableState,
    initialSearch: true,
    trimSearchObjectStringValues: true,
  });

  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        computed: true,
        disableSorting: true,
        fieldName: "actions",
        autoFitContent: true,
        render: (row: PersonGridDto) => (
          <ButtonContainer>
            <Button onClick={() => props.onContactSelected(row)} text={t(ETLCodes.Select)} />
          </ButtonContainer>
        ),
      },
      {
        header: () => t(ETLCodes.Name),
        fieldName: "computedName",
      },
      {
        header: () => t(ETLCodes.Email),
        fieldName: "email",
      },
      {
        fieldName: "address",
        computed: true,
        disableSorting: true,
        header: () => t(ETLCodes.Address),
        render: (row: PersonGridDto) => (
          <div> {generateAddress(row.number, row.street, row.city, row.postalCode, row.country)}</div>
        ),
      },
    ],
    [props, t]
  );

  return (
    <CustomDataTable
      tableState={tableState}
      loading={loading}
      columns={columns}
      filterMode="OnEnter"
      focusOnFilter={true}
    />
  );
};
